<script>
    import {createEventDispatcher, onMount} from "svelte";
    import {fly} from "svelte/transition";

    const dispatch = createEventDispatcher();

    export let title;
    export let type;
    export let id;

    let icon = "";

    let timer = 3000;
    let progress = 100;

    switch(type){
        case "success":
            icon = "check-circle";
            break;
        case "warning":
            icon = "exclamation-circle";
            break;
        case "danger":
            icon = "times-circle";
            break;
        case "info":
            icon = "info-circle";
            break;
    }

    onMount(() => {

        let interval = setInterval(() => {
            progress -= 100 / (timer / 10);
        }, 10);

        setTimeout(() => {
            clearInterval(interval);
            dispatch("delete", {id: id});
        }, timer);

    });

</script>

<div class="notification {type}" in:fly={{ x: 500, duration: 400 }} out:fly={{ x: 500, duration: 200 }}>
    <div class="title">
        <i class="far fa-fw fa-{icon}"></i>
        <h5>{title}</h5>
        <i on:click={() => { dispatch("delete", {id: id}); }} class="fal fa-fw fa-times"></i>
    </div>
    <p><slot /></p>
    <div class="progress-bar">
        <div class="progress-inner" style="width: {progress}%"></div>
    </div>
</div>

<style>
    .notification {
        background-color: white;
        padding: 1.25rem;
        box-shadow: 0 0 17px 0 rgba(0, 0, 0, .06);
        border: 1px solid rgba(0, 0, 0, .1);
        pointer-events: all;
    }
    .notification .title {
        display: flex;
        place-items: center;
        margin-bottom: .75rem;
    }
    .notification .title h5 {
        margin: .15rem 0 0 .65rem;
        line-height: 1.1rem;
        font-size: 1.1rem;
        color: rgba(0, 0, 0, .6);
    }
    .notification .title i.fa-times {
        margin-left: auto;
        cursor: pointer;
    }
    .notification p {
        margin-bottom: 1rem;
    }
    .notification .progress-bar {
        width: 100%;
        height: 2px;
        margin-top: .5rem;
        background-color: rgba(0, 0, 0, .05);
        position: relative;
    }
    .notification .progress-bar .progress-inner {
        height: 2px;
    }

    .notification.success .title i:first-child,
    .notification.success .title h5 {
        color: green;
    }
    .notification.success .progress-inner {
        background-color: green;
    }
    .notification.warning .title i:first-child,
    .notification.warning .title h5 {
        color: orange;
    }
    .notification.warning .progress-inner {
        background-color: orange;
    }
    .notification.danger .title i:first-child,
    .notification.danger .title h5 {
        color: red;
    }
    .notification.danger .progress-inner {
        background-color: red;
    }
    .notification.info .title i:first-child,
    .notification.info .title h5 {
        color: blue;
    }
    .notification.info .progress-inner {
        background-color: blue;
    }
</style>